import { Ratio } from "./basic";
export class AssetExchangeRate extends Ratio {
    constructor(shareMintId, assetMintId, pct) {
        super(pct);
        this.shareMintId = shareMintId;
        this.assetMintId = assetMintId;
    }
    getShareMintId() {
        return this.shareMintId;
    }
    getAssetMintId() {
        return this.assetMintId;
    }
    isCompatibleWith(that) {
        return (this.shareMintId.equals(that.shareMintId) &&
            this.assetMintId.equals(that.assetMintId));
    }
}
//# sourceMappingURL=AssetExchangeRate.js.map